import React from "react"
import Img from "gatsby-image"
import { useStaticQuery, graphql } from "gatsby"
import GalleryBase from "./GalleryBase"

const useGallery = () => {
  const data = useStaticQuery(graphql`
    query {
      allMarkdownRemark(
        sort: { fields: [frontmatter___date], order: DESC }
        filter: { frontmatter: { tags: { in: "outdoor-area" } } }
      ) {
        edges {
          node {
            frontmatter {
              picture {
                childImageSharp {
                  fluid(maxWidth: 500) {
                    ...GatsbyImageSharpFluid
                  }
                }
              }
            }
          }
        }
      }
    }
  `)

  return data.allMarkdownRemark.edges.map(edge => ({
    ...edge.node.frontmatter.picture.childImageSharp,
  }))
}

const OutdoorAreaGalleryComponent = () => (
  <GalleryBase title="Outdoor Areas" images={useGallery()} />
)

export default OutdoorAreaGalleryComponent
